export default "__VITE_ASSET__9a04229d__"